<template>
	<div class="layout">
		<div id="print-content">
		</div>
		<div class="print-config">
			<div class="print-config-title">
				<div class="print-config-title-left">
					打印设置
				</div>
				<div class="print-config-title-right">
					<button class="jxyd-button jxyd-primary" v-print="print">打印</button>
				</div>
			</div>
			<div class="print-config-content">
				<div>
					<span style="color: #000;">单据标题</span>
					<font class="jxyd-required">*</font>
					<Input style="display: inline;width: 300px;" v-model="printConfig.receiptTitle" />
				</div>
				<div class="field-list">
					<CheckboxGroup v-for="(item,index) in printData.attributes" :key="index" style="margin-top: 20px;"
						v-model="printConfig[item]">
						<div class="field-list-title">
							勾选需要打印的{{getAttrDisplayName(item)}}字段
						</div>
						<div class="field-list-item" v-for="(item2,index2) in printData[item]" :key="index2">
							<Checkbox :label="item2.name">
								{{item2.displayName}}
							</Checkbox>
						</div>
					</CheckboxGroup>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'printerpage',
		data() {
			return {
				printConfig: {
					receiptTitle: ''
				},
				printData: []
			}
		},
		created() {},
		watch: {
			printConfig: {
				deep: true,
				handler(param) {
					if (param) {
						this.initPrintContext(this.printData.receipts);
						localStorage.setItem('_printConfig' + this.printData.name, JSON.stringify(this.printConfig));
					}
				}
			},
			'$route': {
				immediate: true,
				handler(param) {
					if (param) {
						this.initPage();
					}
				}
			}
		},
		methods: {
			initPage() {
				let printData = JSON.parse(localStorage.getItem("_printData"));
				if (printData) {
					this.printData = printData;
					localStorage.removeItem("_printData");
				}
				let data = localStorage.getItem('_printConfig' + this.printData.name)
				if (data) {
					this.printConfig = JSON.parse(data)
				} else {
					this.printConfig.receiptTitle = this.printData.title;
					for (let i = 0; i < this.printData.attributes.length; i++) {
						this.$set(this.printConfig, this.printData.attributes[i], []);
						for (let n = 0; n < 5; n++) {
							if (this.printData[this.printData.attributes[i]].length <= n) {
								break;
							}
							this.printConfig[this.printData.attributes[i]].push(this.printData[this.printData
								.attributes[
									i]][n].name);
						}
					}
				}
			},
			initPrintContext(data) {
				let printHtml = '';
				for (var f = 0; f < data.length; f++) {
					printHtml += '<div class="print-item">';
					printHtml += '<h3 style="text-align:center;">' + this.printConfig.receiptTitle + '</h3>';
					for (let j = 0; j < this.printData.attributes.length; j++) {
						if (!data[f][this.printData.attributes[j]]) {
							if (this.printConfig[this.printData.attributes[j]]) {
								printHtml += '<div class="print-item-part1">';
								for (let i = 0; i < this.printConfig[this.printData.attributes[j]].length; i++) {
									for (let n = 0; n < this.printData[this.printData.attributes[j]].length; n++) {
										if (this.printData[this.printData.attributes[j]][n].name == this.printConfig[this
												.printData.attributes[j]][i]) {
											printHtml += '<div class="print-item-part1-item">';
											printHtml += '<span style="font-weight: bold;">' + this.printData[this
													.printData.attributes[j]][n]
												.displayName + ':</span>';
											printHtml += '<span>' + data[f][this.printConfig[this.printData.attributes[j]][
												i
											]] + '</span>';
											printHtml += '</div>';
											break;
										}
									}
								}
								printHtml += '</div>';
								printHtml += '<div class="print-item-division"></div>';
							}
						} else {
							if (data[f][this.printData.attributes[j]].length <= 0) {
								continue
							}
							if (this.printConfig[this.printData.attributes[j]]) {
								printHtml += '<div class="print-item-part2">';
								for (let h = 0; h < this.printConfig[this.printData.attributes[j]].length; h++) {
									for (let i = 0; i < this.printData[this.printData.attributes[j]].length; i++) {
										if (this.printConfig[this.printData.attributes[j]][h] == this.printData[this
												.printData.attributes[j]][i].name) {
											printHtml += '<div class="print-item-part2-head">';
											printHtml += '<span>' + this.printData[this.printData.attributes[j]][i]
												.displayName + '</span>';
											printHtml += '</div>';
											break;
										}
									}
								}
								printHtml += '</div>';
								for (let n = 0; n < data[f][this.printData.attributes[j]].length; n++) {
									printHtml += '<div class="print-item-part2">';
									let array = [];
									for (let i = 0; i < this.printConfig[this.printData.attributes[j]].length; i++) {
										let value = data[f][this.printData.attributes[j]][n][this.printConfig[
											this.printData.attributes[j]][i]];
										array.push(value);
									}
									if(array.filter(m=> m).length > 0){
										array.forEach(item=>{
											printHtml += '<div class="print-item-part2-content">';
											printHtml += '<span>' + item + '</span>';
											printHtml += '</div>';
										})
									}
									printHtml += '</div>';
								}
							}
							printHtml += '<div class="print-item-division"></div>';
						}
					}
					printHtml += '</div>';
				}
				setTimeout(function() {
					document.getElementById('print-content').innerHTML = printHtml;
				}, 300)
			},
			print() {
				window.print();
			},
			getAttrDisplayName(param){
				if(param.indexOf('base')>-1){
					return '单据';
				}else if(param.indexOf('Cost')>-1){
					return '费用信息';
				}else if(param.indexOf('Receipe')>-1){
					return '费用信息';
				}else if(param.indexOf('Detail')>-1){
					return '商品';
				}else if(param.indexOf('Package')>-1){
					return '套餐';
				}else if(param.indexOf('extra')>-1){
					return '额外费用';
				}else if(param.indexOf('logistics')>-1){
					return '物流信息';
				}
			}
		}
	}
</script>

<style>
	.layout {
		overflow: hidden;
	}

	#print-content {
		width: 70%;
		float: left;
	}

	.print-config {
		float: left;
		width: 29%;
		margin-left: 1%;
	}

	.print-config-title {
		background-color: white;
		border-radius: 30px;
		padding: 10px;
		margin-bottom: 10px;
		border-left: 3px solid rgb(255, 106, 127);
		color: #000;
		font-weight: bold;
		overflow: hidden;
	}

	.print-config-title-left {
		float: left;
		line-height: 32px;
		height: 32px;
	}

	.print-config-title-right {
		float: right;
	}

	.print-config-content {
		background-color: white;
		padding: 10px;
		border-radius: 10px;
	}

	.field-list-title {
		margin-bottom: 10px;
		color: #000;
		border-left: 3px solid rgb(255, 106, 127);
		padding-left: 5px;
	}

	.field-list-item {
		font-size: 8px;
		margin-bottom: 10px;
	}

	.print-item {
		padding: 20px;
		margin-bottom: 20px;
		font-size: 14px;
		background-color: white;
	}

	.print-item-part1 {
		overflow: hidden;
		margin-top: 20px;
	}

	.print-item-part1-item {
		width: 33.3%;
		float: left;
		margin-bottom: 15px;
	}

	.print-item-part2 {
		display: flex;
		flex-wrap: nowrap;
	}

	.print-item-part2-head {
		font-weight: bold;
		width: 150px;
	}

	.print-item-part2-content{
		width: 150px;
	}
	
	.print-item-division{
		width:100%;
		border-bottom:1px dotted;
		margin-top:15px;
		margin-bottom:15px;
	}

	@media print {
		#app * {
			display: none;
		}

		.index-vue,
		.sec-right,
		.main-content,
		.view-c,
		.layout {
			display: block !important;
			margin: 0px !important;
			height: auto !important;
			min-height: auto !important;
			width: 100%;
		}

		#print-content {
			display: block !important;
			margin: 0px !important;
			padding: 0px;
			width: 100%;
		}

		.print-item {
			display: block !important;
			page-break-after: always;
			padding: 0px;
		}

		h3,
		.print-item-part1,
		.print-item-part1-item,
		.print-item-part2-head,
		.print-item-part2-content,
		.print-item-division {
			display: block !important;
		}

		.print-item-part2 {
			display: flex !important;
		}

		span {
			display: inline !important;
		}
	}
</style>